// Dependencies
import styled, { css } from 'styled-components';

// Types
import { ContainerProps } from './types';

import { VisibilityIcon } from '../../../../assets/icons/VisibilityIcon';

export const Container = styled.button<ContainerProps>`
  background-color: ${({ theme }) => theme.colors.garnet};
  align-self: flex-end;
  width: 3.4rem;
  height: 3.4rem;
  border-radius: ${({ theme }) => theme.borderRadius.full};
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
  border: none;
  flex-shrink: 0;
  cursor: pointer;
  position: relative;
  &:disabled {
    opacity: 0.35;
    cursor: not-allowed;
    pointer-events: none;
  }
  &:focus {
    outline: 0.2rem solid ${({ theme }) => theme.colors.black};
  }
  /* V4 D3 (2026-05-27): focus-visible-only para el variant 'clock'.
     Patrón estándar web (Material UI / Radix / GitHub Primer):
     outline: none en :focus (no se ve tras click) +
     :focus-visible (sí se ve con navegación por teclado). Solo
     aplicado al variant clock del TimerOverlay porque el resto del
     design system mantiene el outline negro por consistencia. */
  ${({ variant }) =>
    variant === 'clock' &&
    css`
      &:focus {
        outline: none;
      }
      &:focus-visible {
        outline: 0.2rem solid ${({ theme }) => theme.colors.black};
      }
    `}
  &[data-tooltip]:hover::after {
    content: attr(data-tooltip);
    position: absolute;
    top: calc(100% + 0.8rem);
    left: 50%;
    transform: translateX(-50%);
    background: rgba(0, 0, 0, 0.88);
    color: white;
    padding: 0.6rem 1.1rem;
    border-radius: 0.5rem;
    font-size: 1rem;
    white-space: nowrap;
    z-index: 1000;
    pointer-events: none;
    box-shadow: 0 0.3rem 0.8rem rgba(0, 0, 0, 0.25);
    font-weight: 500;
    letter-spacing: 0.02rem;
  }
  &[data-tooltip]:hover::before {
    content: '';
    position: absolute;
    top: calc(100% + 0.1rem);
    left: 50%;
    transform: translateX(-50%);
    border: 0.5rem solid transparent;
    border-bottom-color: rgba(0, 0, 0, 0.88);
    z-index: 1000;
    pointer-events: none;
  }
`;

export const VisibilityImg = styled(VisibilityIcon)`
  width: 2rem;
  height: 1.3rem;
  @media (max-width: ${({ theme }) =>
    theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    width: 1.4rem;
    height: 0.9rem;
  }
`;

export const RestartImg = styled.img`
  width: 1.8rem;
  height: 1.8rem;
  @media (max-width: ${({ theme }) =>
    theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    width: 1.4rem;
    height: 1.4rem;
  }
`;

export const EditImg = styled.img`
  width: 1.5rem;
  height: 1.7rem;
  @media (max-width: ${({ theme }) =>
    theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    width: 1.2rem;
    height: 1.4rem;
  }
`;

export const SaveImg = styled.img`
  width: 1.8rem;
  height: 1.8rem;
  @media (max-width: ${({ theme }) =>
    theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    width: 1.4rem;
    height: 1.4rem;
  }
`;

export const AddImg = styled.img`
  width: 2rem;
  height: 2rem;
`;

export const DeleteImg = styled.img`
  width: 1.7rem;
  height: 1.7rem;
  @media (max-width: ${({ theme }) =>
    theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    width: 1.4rem;
    height: 1.4rem;
  }
`;

export const CheckImg = styled.img`
  width: 2rem;
  height: 2rem;
`;

export const CancelImg = styled.img`
  width: 2rem;
  height: 2rem;
`;

export const DianaImg = styled.img`
  width: 2rem;
  height: 2rem;
`;

export const SearchImg = styled.img`
  width: 2rem;
  height: 2rem;
`;

export const DownloadImg = styled.img`
  width: 2rem;
  height: 2rem;
  filter: brightness(0) invert(1);
`;

/**
 * V4 D3 (2026-05-27) — wrapper para el icono Clock (variant 'clock'
 * del TimerOverlay). 2.4rem (= theme.sizes.iconSize) en desktop, 2rem
 * en landscapeTablet. Más grande que los otros iconos del set
 * (RestartImg=1.8, SaveImg=1.8, EditImg=1.5×1.7) porque vive sobre
 * un botón aislado en el header, no en grupos densos como las
 * acciones de tabla — necesita peso visual propio para que se lea
 * como "pulsable" y no como "símbolo perdido".
 *
 * Color white forzado (el SVG es stroke="currentColor"; el Container
 * tiene bg garnet, el texto se hereda como del body — sin esto
 * heredaría el color del documento). */
export const ClockIconWrap = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.white};
  width: ${({ theme }) => theme.sizes.iconSize};
  height: ${({ theme }) => theme.sizes.iconSize};
  & > svg {
    width: 100%;
    height: 100%;
  }
  @media (max-width: ${({ theme }) =>
    theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    width: 2rem;
    height: 2rem;
  }
`;
